// extracted by mini-css-extract-plugin
export default {"quizes_container":"Quizes_quizes_container__rfYg6","quiz_title":"Quizes_quiz_title__AVff6"};